// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UploadImageBoxNew_box__pQCQk {
  -webkit-user-select: none;
          user-select: none;
  height: 200px;
}

.UploadImageBoxNew_box__pQCQk label {
  color: var(--secondary-color);
  text-transform: capitalize;

  font-size: 20px;
}

.UploadImageBoxNew_label__1YhgR {
  display: block;
  font-size: 20px;
  font-weight: 700;
}
.UploadImageBoxNew_subLabel__cWx7X {
  display: block;
  color: var(--text-color-light);
  text-transform: capitalize;
  font-size: 12px;
  margin-bottom: 10px;
}

.UploadImageBoxNew_uploadImageBox__trRVL {
  width: 100%;
  border-radius: 10px;
  height: 100%;
  box-shadow: 0px 0 5px 2px #0000000d;
  position: relative;
}

.UploadImageBoxNew_uploadBox__gPEJR {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: 100%;
}

.UploadImageBoxNew_uploadBox__gPEJR .UploadImageBoxNew_icon__ASqhh {
  margin: auto 0px;
  height: 22px;
  width: 25px;
  color: var(--label-color);
}

.UploadImageBoxNew_uploadBox__gPEJR .UploadImageBoxNew_uploadIcon__zobnQ {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.UploadImageBoxNew_uploadBox__gPEJR .UploadImageBoxNew_uploadIcon__zobnQ svg {
  color: var(--primary-color);
  font-size: 35px;
}

.UploadImageBoxNew_uploadBox__gPEJR .UploadImageBoxNew_uploadIconDisabled__QuLjI svg {
  color: var(--disabled-label-color);
  font-size: 35px;
}

/* Image Uploaded */
.UploadImageBoxNew_imageUploaded__xeYfU {
  width: 100%;
  height: 100%;
  border-radius: inherit;
  position: relative;
}

.UploadImageBoxNew_imageUploaded__xeYfU img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top center;
  border-radius: inherit;
}

.UploadImageBoxNew_imageUploaded__xeYfU .UploadImageBoxNew_editAndDelete__29nQD {
  position: absolute;
  top: 10px;
  right: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.UploadImageBoxNew_imageUploaded__xeYfU .UploadImageBoxNew_editAndDelete__29nQD .UploadImageBoxNew_icon__ASqhh {
  background-color: var(--black-color);
  padding: 8px;
  border-radius: 7px;
  cursor: pointer;
  box-shadow: 0px 0px 3px 1px #afa8a8;
}

.UploadImageBoxNew_imageUploaded__xeYfU .UploadImageBoxNew_editAndDelete__29nQD .UploadImageBoxNew_icon__ASqhh svg {
  color: var(--white-color);
  vertical-align: middle;
  width: 16px;
  height: 16px;
  display: inherit;
}

.UploadImageBoxNew_closeIcon__989Ne {
  position: absolute;
  top: 10px;
  left: 12px;
  background-color: var(--black-color);
  padding: 8px;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0px 0px 3px 1px #afa8a8;
  z-index: 2;
}

.UploadImageBoxNew_closeIcon__989Ne svg {
  color: var(--white-color);
  vertical-align: middle;
  display: flex;
}

.UploadImageBoxNew_label__1YhgR {
  color: var(--secondary-color);
  text-transform: capitalize;

  font-size: 16px;
  margin-bottom: 10px;
}

.UploadImageBoxNew_imgDiv__8k0rY {
  height: 200px;
}

.UploadImageBoxNew_imgDiv__8k0rY img {
  object-fit: contain;
  height: 100%;
  width: 100%;
}

@media screen and (max-width: 600px) {
  .UploadImageBoxNew_box__pQCQk {
    height: 180px;
  }
}

@media screen and (max-width: 500px) {
  .UploadImageBoxNew_box__pQCQk {
    height: 160px;
  }
}

@media screen and (max-width: 425px) {
  .UploadImageBoxNew_box__pQCQk {
    height: 140px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/molecules/UploadImageBoxNew/UploadImageBoxNew/UploadImageBoxNew.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAiB;UAAjB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;;EAE1B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,8BAA8B;EAC9B,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mCAAmC;EACnC,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;;EAE1B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".box {\n  user-select: none;\n  height: 200px;\n}\n\n.box label {\n  color: var(--secondary-color);\n  text-transform: capitalize;\n\n  font-size: 20px;\n}\n\n.label {\n  display: block;\n  font-size: 20px;\n  font-weight: 700;\n}\n.subLabel {\n  display: block;\n  color: var(--text-color-light);\n  text-transform: capitalize;\n  font-size: 12px;\n  margin-bottom: 10px;\n}\n\n.uploadImageBox {\n  width: 100%;\n  border-radius: 10px;\n  height: 100%;\n  box-shadow: 0px 0 5px 2px #0000000d;\n  position: relative;\n}\n\n.uploadBox {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  height: 100%;\n}\n\n.uploadBox .icon {\n  margin: auto 0px;\n  height: 22px;\n  width: 25px;\n  color: var(--label-color);\n}\n\n.uploadBox .uploadIcon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n\n.uploadBox .uploadIcon svg {\n  color: var(--primary-color);\n  font-size: 35px;\n}\n\n.uploadBox .uploadIconDisabled svg {\n  color: var(--disabled-label-color);\n  font-size: 35px;\n}\n\n/* Image Uploaded */\n.imageUploaded {\n  width: 100%;\n  height: 100%;\n  border-radius: inherit;\n  position: relative;\n}\n\n.imageUploaded img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: top center;\n  border-radius: inherit;\n}\n\n.imageUploaded .editAndDelete {\n  position: absolute;\n  top: 10px;\n  right: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.imageUploaded .editAndDelete .icon {\n  background-color: var(--black-color);\n  padding: 8px;\n  border-radius: 7px;\n  cursor: pointer;\n  box-shadow: 0px 0px 3px 1px #afa8a8;\n}\n\n.imageUploaded .editAndDelete .icon svg {\n  color: var(--white-color);\n  vertical-align: middle;\n  width: 16px;\n  height: 16px;\n  display: inherit;\n}\n\n.closeIcon {\n  position: absolute;\n  top: 10px;\n  left: 12px;\n  background-color: var(--black-color);\n  padding: 8px;\n  border-radius: 50%;\n  cursor: pointer;\n  box-shadow: 0px 0px 3px 1px #afa8a8;\n  z-index: 2;\n}\n\n.closeIcon svg {\n  color: var(--white-color);\n  vertical-align: middle;\n  display: flex;\n}\n\n.label {\n  color: var(--secondary-color);\n  text-transform: capitalize;\n\n  font-size: 16px;\n  margin-bottom: 10px;\n}\n\n.imgDiv {\n  height: 200px;\n}\n\n.imgDiv img {\n  object-fit: contain;\n  height: 100%;\n  width: 100%;\n}\n\n@media screen and (max-width: 600px) {\n  .box {\n    height: 180px;\n  }\n}\n\n@media screen and (max-width: 500px) {\n  .box {\n    height: 160px;\n  }\n}\n\n@media screen and (max-width: 425px) {\n  .box {\n    height: 140px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `UploadImageBoxNew_box__pQCQk`,
	"label": `UploadImageBoxNew_label__1YhgR`,
	"subLabel": `UploadImageBoxNew_subLabel__cWx7X`,
	"uploadImageBox": `UploadImageBoxNew_uploadImageBox__trRVL`,
	"uploadBox": `UploadImageBoxNew_uploadBox__gPEJR`,
	"icon": `UploadImageBoxNew_icon__ASqhh`,
	"uploadIcon": `UploadImageBoxNew_uploadIcon__zobnQ`,
	"uploadIconDisabled": `UploadImageBoxNew_uploadIconDisabled__QuLjI`,
	"imageUploaded": `UploadImageBoxNew_imageUploaded__xeYfU`,
	"editAndDelete": `UploadImageBoxNew_editAndDelete__29nQD`,
	"closeIcon": `UploadImageBoxNew_closeIcon__989Ne`,
	"imgDiv": `UploadImageBoxNew_imgDiv__8k0rY`
};
export default ___CSS_LOADER_EXPORT___;
